// extracted by mini-css-extract-plugin
export default {"header":"AddFormCard_header__ZdQY1","title":"AddFormCard_title__VbP37","actions":"AddFormCard_actions__g-AJt","content":"AddFormCard_content__mL6q0"};